module.exports = __webpack_public_path__ + "img/logo-rolling-stone.81e6e0c4.png";